import { memo, useCallback, useMemo, useState, useTransition } from "react";

import { CircleLoading } from "@/components/ui/loading/circle";

import { RoomStockTableForLaptop } from "./components/table";
import { YearAndMonthSelectBox } from "../../../../_shared";
import { FilterInSaleAndStopSellingForLaptop } from "../../../../_shared/components/filter/filter-insale-and-stop-selling/components";
import { useCreateInSaleAndStopSellingFilterProps } from "../hooks";

import type { RoomStockDiffStore } from "../../../model/usecase/use-create-form-model/room-stock-diff-store";
import type { ServerModel } from "../../../model/usecase/use-create-form-model/type";

type Props = {
	todaysDt: string;

	handleOnSelectYearOrMonth: (input: { startDt: string; endDt: string }) => Promise<void>;

	serverModel: ServerModel;
	roomStockDiffStore: RoomStockDiffStore;
};

export const RoomStockManagementForLaptop = memo(
	({ serverModel, roomStockDiffStore, todaysDt, handleOnSelectYearOrMonth }: Props) => {
		const { inSaleItems, stopSellingItems, itemsName } = useCreateInSaleAndStopSellingFilterProps({ serverModel });

		const initialSelectedItemIDs: string[] = useMemo(() => {
			if (inSaleItems.length >= 15) {
				return [inSaleItems.at(0)?.id || ""];
			}

			return inSaleItems.map((item) => item.id);
		}, [inSaleItems]);

		const [isPending, startTransition] = useTransition();
		const [selectedItemIDs, setSelectedItemIDs] = useState<string[]>(initialSelectedItemIDs);
		const onChangeSelectedItemIDs = useCallback((input: string[]) => {
			startTransition(() => {
				setSelectedItemIDs(input);
			});
		}, []);

		return (
			<>
				<div className="flex flex-col gap-y-6">
					<YearAndMonthSelectBox
						initialDt={todaysDt}
						onSelectYearOrMonthCallback={handleOnSelectYearOrMonth}
					/>
					<FilterInSaleAndStopSellingForLaptop
						isPending={isPending}
						itemsName={itemsName}
						selectedItemIDs={selectedItemIDs}
						onChangeSelectedItemIDs={onChangeSelectedItemIDs}
						inSaleItems={inSaleItems}
						stopSellingItems={stopSellingItems}
					/>
				</div>
				{isPending ? (
					<CircleLoading size="sm" />
				) : (
					<RoomStockTableForLaptop
						serverModel={serverModel}
						roomStockDiffStore={roomStockDiffStore}
						selectedItemIDs={selectedItemIDs}
					/>
				)}
			</>
		);
	},
);

RoomStockManagementForLaptop.displayName = "RoomStockManagementForLaptop";
